import {FC} from 'react'
import {ColumnInstance} from 'react-table'
import {ModSession} from "@providers/session/_modals";
import {TransactionsGeneralResponse} from "@providers/adminTransactions/_models";

type Props = {
    column: ColumnInstance<any>
}

const CustomHeaderColumn: FC<Props> = ({column}) => (
    <>
        {column.Header && typeof column.Header === 'string' ? (
            <th {...column.getHeaderProps()}>{column.render('Header')}</th>
        ) : (
            column.render('Header')
        )}
    </>
)

export {CustomHeaderColumn}
